import { Award, ShieldCheck, TrendingUp, Users } from "lucide-react";
import { ParceirosV2HeroForm } from "./ParceirosV2HeroForm";
import { Eyebrow } from "./Eyebrow";

export const ParceirosV2Hero = () => {
  return (
    <section className="relative bg-[#FAF8F5]">
      <div className="container-wide px-6 sm:px-6 md:px-12 pt-8 sm:pt-20 md:pt-24 pb-12 sm:pb-24 md:pb-28">
        <div className="grid gap-8 lg:gap-16 lg:grid-cols-12">
          {/* Coluna esquerda — texto (60% desktop). Espaçamento generoso
              (badge→headline 24px, headline→parágrafo 24px, parágrafo→box
              32px, box→stats 32px) + tipografia ~12% maior em todo o bloco,
              pra a altura total bater com o card do form ao lado. */}
          <div className="flex flex-col justify-center min-h-[calc(100dvh-77px)] lg:min-h-0 lg:flex lg:flex-col lg:col-span-7">
            {/* No desktop, kicker / headline+subheadline / box de corte /
                bullets são 4 blocos com espaçamento IGUAL entre si.
                lg:flex-1 faz esse bloco crescer até a altura real da coluna
                (que o grid já estica pra bater com o form ao lado), dando ao
                justify-between espaço de verdade pra distribuir 3 gaps
                iguais. No mobile, kicker e box ficam ocultos e os blocos
                restantes fluem normalmente com as margens abaixo. */}
            <div className="lg:flex-1 lg:flex lg:flex-col lg:justify-between">
              <div className="hidden lg:block">
                <Eyebrow className="bg-[#D1F8E2] text-[#112711]">
                  Allu Investimentos - Parceiros
                </Eyebrow>
              </div>

              <div>
                <h1
                  className="text-[#323F4F] font-extrabold leading-[1.25] tracking-tight text-[2.1rem] sm:text-[2.5rem] md:text-[2.8rem] max-w-lg"
                  style={{
                    fontFamily:
                      '"Plus Jakarta Sans", Inter, system-ui, sans-serif',
                    letterSpacing: "-0.03em",
                  }}
                >
                  Ofereça um Investimento para diferenciar o seu portifólio
                </h1>

                <p className="text-lg sm:text-xl font-normal text-zinc-600 leading-relaxed mt-8 lg:mt-6 max-w-lg">
                  Saia do óbvio: ofereça aos seus clientes investimentos em
                  crédito estruturado da Allu, com lastro em contratos de
                  recebíveis e rentabilidade de até 24% ao ano.
                </p>
              </div>

              <div className="hidden lg:block">
                <div className="inline-flex items-start gap-3 rounded-xl bg-[#1F3D2E] px-5 py-4 max-w-lg shadow-sm">
                  <ShieldCheck className="w-[18px] h-[18px] text-[#B8934A] mt-[4.5px] flex-shrink-0" />
                  <p className="text-base sm:text-lg font-semibold text-white leading-snug">
                    Para profissionais do mercado financeiro com{" "}
                    <span className="whitespace-nowrap">R$5 milhões</span> ou
                    mais sob custódia.
                  </p>
                </div>
              </div>

              {/* Prova social. Números já usados em TrustBar/SobreAllu.
                  Quando houver logos de parceiros/assessores reais, trocar
                  por uma faixa de logos aqui. */}
              <div className="flex flex-wrap lg:flex-nowrap items-center gap-x-5 gap-y-2 mt-16 lg:mt-0 lg:max-w-lg lg:justify-between">
                <span className="inline-flex flex-shrink-0 items-center gap-1.5 text-base font-semibold text-[#1F3D2E]">
                  <Award className="w-[18px] h-[18px]" />
                  10 anos de mercado
                </span>
                <span className="inline-flex flex-shrink-0 items-center gap-1.5 text-base font-semibold text-[#1F3D2E]">
                  <Users className="w-[18px] h-[18px]" />
                  +60.000 clientes ativos
                </span>
                <span className="inline-flex flex-shrink-0 items-center gap-1.5 text-base font-semibold text-[#1F3D2E]">
                  <TrendingUp className="w-[18px] h-[18px]" />
                  100% de adimplência
                </span>
              </div>
            </div>
          </div>

          {/* Coluna direita — form (40% desktop, abaixo no mobile). No
              mobile, min-h força o form a começar numa "dobra" própria (não
              dividir espaço visível com o texto da hero) — 77px é a altura do
              header sticky. */}
          <div className="flex items-center min-h-[calc(100dvh-77px)] lg:min-h-0 lg:block lg:col-span-5">
            <div className="w-full">
              <ParceirosV2HeroForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
